import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TrackerService } from 'src/app/shared/util/tracker.service';
import { environment } from 'src/environments/environment';

export interface FeatureItem {
  icon: string;
  titleKey: string;
  textKey: string;
}

export interface RelatedLink {
  route: string;
  icon: string;
  titleKey: string;
  textKey: string;
}

@Component({
  selector: 'app-todo',
  templateUrl: './todo.component.html',
  styleUrls: ['./todo.component.scss'],
})
export class TodoComponent implements OnInit {
  assistantHref = '';

  readonly features: FeatureItem[] = [
    { icon: 'lni-checkbox', titleKey: 'TODO_LISTS.FEATURE_1_TITLE', textKey: 'TODO_LISTS.FEATURE_1_TEXT' },
    { icon: 'lni-timer', titleKey: 'TODO_LISTS.FEATURE_2_TITLE', textKey: 'TODO_LISTS.FEATURE_2_TEXT' },
    { icon: 'lni-alarm', titleKey: 'TODO_LISTS.FEATURE_3_TITLE', textKey: 'TODO_LISTS.FEATURE_3_TEXT' },
    { icon: 'lni-users', titleKey: 'TODO_LISTS.FEATURE_4_TITLE', textKey: 'TODO_LISTS.FEATURE_4_TEXT' },
  ];

  readonly relatedLinks: RelatedLink[] = [
    { route: '/management-tool', icon: 'lni-dashboard', titleKey: 'HOME.MANAGEMENT_TOOL_TITLE', textKey: 'HOME.MANAGEMENT_TOOL_TEXT_SHORT' },
    { route: '/calculators', icon: 'lni-calculator', titleKey: 'HOME.CALCULATORS_TITLE', textKey: 'HOME.CALCULATORS_TEXT_SHORT' },
    { route: '/documents', icon: 'lni-files', titleKey: 'HOME.DOCUMENTS_AND_TEMPLATES_TITLE', textKey: 'HOME.DOCUMENTS_AND_TEMPLATES_TEXT_SHORT' },
    { route: '/help', icon: 'lni-support', titleKey: 'HOME.HELP_CENTER_TITLE', textKey: 'HOME.HELP_CENTER_TEXT_SHORT' },
  ];

  constructor(
    public translate: TranslateService,
    private trackerService: TrackerService
  ) {}

  ngOnInit(): void {
    this.trackerService.trackPageViews();
    this.assistantHref = environment.assistantApp;
  }
}
